import { createContext, type Ref, use } from "react";
import type { StrictOmit } from "ts-essentials";
import type { MapsImperativeApi, MapsProps } from "./types";

export type MapsContextValue = {
    mapsRootNode: HTMLDivElement;
    mapsProps: MapsProps;
    mapsImperativeApiRef: Ref<MapsImperativeApi | undefined> | undefined;
};

export const MapsContext = createContext<MapsContextValue | undefined>(
    undefined,
);

type UseMapsReturn = {
    mapsRootNode: MapsContextValue["mapsRootNode"];
    // "onEvent" and "onTrackingEvent" are excluded because we should use useSendEvent() or useSaveTrackingEvent() hooks instead
    mapsProps: StrictOmit<
        MapsContextValue["mapsProps"],
        "onEvent" | "onTrackingEvent"
    >;
    mapsImperativeApiRef: MapsContextValue["mapsImperativeApiRef"];
};

export function useMaps(): UseMapsReturn {
    const contextValue = use(MapsContext);

    if (contextValue === undefined) {
        throw new Error(
            "useMaps() was called before MapsContext value was properly initialized.",
        );
    }

    return contextValue;
}
